import { RefObject } from 'preact';
import { useEffect } from 'preact/hooks';
import { PX, shouldBarsBeVisible, style } from '../social/lib';
import { useResizeObserver } from './useResizeObserver';

const MutationObserverOptions: MutationObserverInit = {
  attributes: true,
  attributeFilter: ['width', 'height', 'style'],
};

export function useMoveVideoSlotInContainer(
  adSize: { width: number },
  videoSlotContainerRef: RefObject<HTMLElement>,
  videoSlot: HTMLVideoElement,
  videoRatio: number
) {
  let { width, height } = useResizeObserver(videoSlotContainerRef.current);
  width = Math.round(width);
  height = Math.round(height);

  useEffect(() => {
    if (!adSize.width) return;
    const { top: offsetTop = 0, left: offsetLeft = 0 } =
      videoSlotContainerRef.current?.offsetParent?.getBoundingClientRect() || {};
    const { top = 0, left = 0 } = videoSlotContainerRef.current?.getBoundingClientRect() || {};
    const areBarsVisible = shouldBarsBeVisible(adSize.width, videoRatio ? adSize.width / videoRatio : 0, width, height);
    style(videoSlot, {
      position: 'absolute',
      top: PX(top - offsetTop),
      left: PX(left - offsetLeft),
      width: PX(width),
      height: PX(height),
      objectFit: 'contain',
      background: areBarsVisible ? '#000000' : 'transparent',
    });
    videoSlot.width = width;
    videoSlot.height = height;

    const mo = new MutationObserver((mutations: MutationRecord[]) => {
      for (let i = 0; i < mutations.length; i++) {
        const m = mutations[i];

        switch (m.attributeName) {
          case 'width':
            if (Math.abs(videoSlot.width - width) >= 1) {
              videoSlot.width = width;
            }
            break;
          case 'height':
            if (Math.abs(videoSlot.height - height) >= 1) {
              videoSlot.height = height;
            }
            break;
          case 'style':
            if (
              Math.abs(parseFloat(videoSlot.style.width) - width) >= 1 ||
              Math.abs(parseFloat(videoSlot.style.height) - height) >= 1
            ) {
              style(videoSlot, {
                width: PX(width),
                height: PX(height),
              });
            }
            break;
        }
      }
    });

    mo.observe(videoSlot, MutationObserverOptions);
    return () => {
      return mo.disconnect();
    };
  }, [adSize, width, height]);
}
